<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <!--列表-->
    <el-form  class="user-search">
      <el-form-item>
      <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加菜单</el-button>
      </el-form-item>
    </el-form>
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="id" label="序号" width="100">
      </el-table-column>
      <el-table-column sortable prop="display_name" label="菜单名称" width="200">
        <template slot-scope="scope">
          <router-link :to="{  path: '/system/Menu', query: {parent_id: scope.row.id,level:level+1}}">
            <el-button type="text" size="small" >{{  scope.row.display_name }}</el-button>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column sortable prop="name" label="URL" width="200">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="200">
        <template slot-scope="scope">

          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteMenu(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="菜单名称" prop="display_name">
          <el-input size="small" v-model="editForm.display_name" auto-complete="off" placeholder="请输入菜单名称"></el-input>
        </el-form-item>
        <el-form-item label="URL" prop="name">
          <el-input size="small" v-model="editForm.name"  placeholder="请输入URL"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMenu,addMenu,updateMenu,deleteMenu } from '../../api/menu'

import { deptList, deptSave, deptDelete } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import {
  pcaTextArr,
} from "element-china-area-data";
export default {
  data() {
    return {
      parent_id:this.$route.query.parent_id?this.$route.query.parent_id :0,
      level:this.$route.query.level?this.$route.query.level:0,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        parent_id: '',
        name: '',
        display_name: '',
        level: '',
      },
      // rules表单验证
      rules: {
        // name: [
        //   { required: true, message: '请输入URL', trigger: 'blur' }
        // ],
        display_name: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' }
        ],
      },
      formInline: {
        parent_id: this.$route.query.parent_id?this.$route.query.parent_id :0,
        level:this.$route.query.level?this.$route.query.level:0
      },
      // 删除部门
      seletedata: {
        ids: '',
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
    }
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata()
  },
  watch: {
    '$route'(to, from) {
      this.getdata();
    },
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata() {
      this.loading = true
      this.formInline.parent_id = this.$route.query.parent_id?this.$route.query.parent_id :0
      this.formInline.level = this.$route.query.level?this.$route.query.level:0
      getMenu(this.formInline).then(res => {
        if (res.code == 0) {
          this.loading = false
          this.listData = res.data

        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.parent_id = row.parent_id
        this.editForm.path = row.path? row.path:''
        this.editForm.name = row.name
        this.editForm.display_name = row.display_name
        this.editForm.guard_name = row.guard_name
        this.editForm.sort = row.sort
        this.editForm.is_menu = row.is_menu
        this.editForm.level = row.level
        this.editForm.id = row.id
      } else {
        this.title = '添加'
        this.editForm =  {
          parent_id: this.$route.query.parent_id?this.$route.query.parent_id :0,
          level: this.$route.query.level?this.$route.query.level:0,
          name: '',
          display_name: '',
          sort:0,
          is_menu:1,
        }
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.id){
            updateMenu(this.editForm.id, this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code ==0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }else{
            addMenu(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code ==0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '添加成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('添加失败，请稍后再试！')
            })
          }

        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteMenu(index, row) {
      this.$confirm('此操作将删除该菜单及子菜单, 是否继续?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteMenu(row.id)
            .then(res => {
              if (res.code == 0 ) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/system/Menu.vue